import React, { useMemo } from "react";
import { useCurrency } from "./use-currency";

const BillingContext = React.createContext<{
  currency: ReturnType<typeof useCurrency>;
  refetch: () => void;
  error?: any;
}>(null);

export const BillingProvider: FCwC = ({ children }) => {
  const currency = useCurrency();
  const values = {
    error: null,
    refetch: () => {},
    currency,
  };

  return (
    <BillingContext.Provider value={values}>{children}</BillingContext.Provider>
  );
};

export const useBillingContext = () => {
  const context = React.useContext(BillingContext);

  if (context === undefined) {
    throw new Error("useBillingContext must be used within a BillingProvider");
  }

  return context;
};

export const useBillingCurrency = () => {
  const billingContext = useBillingContext();
  return useMemo(() => {
    const { currency, ...rest } = billingContext;
    return { ...rest, ...currency };
  }, [billingContext]);
};
